import { queryOptions } from '@tanstack/react-query'
import { apiExchange, apiGet } from './client'
import { saveBytes } from './inventoree'

/**
 * Settings -> Reports -> Cost Reports, calea noua. Perechile vechi:
 *
 *   settings/Company_reports::cost_report / cost_settings_report
 *                                      -> GET /settings/company-reports/cost?from_ym=&to_ym=
 *   settings/Company_reports::generateCostReportExcel($view)
 *                                      -> GET /settings/company-reports/cost/export.xlsx?view=&from_ym=&to_ym=
 *   (nou in v4: si export.csv / export.pdf, aceleasi coloane)
 *
 * Calea NU poarta `/api/v2`: il pune `apiGet`. Clientul NU e parametru: e cel
 * ales in bara de sus, ca in portal (firma din token).
 */

export type CostView = 'service' | 'customer' | 'consumption'

export type CostReportPage = {
  moduleUrl: string
  months: { ym: number; label: string }[]
  filters: { from_ym: number; to_ym: number; company_id: number }
  data: {
    service: { service: string; category: string; kind: string; currency: string; amount: number; customers: number }[]
    customer: { customer: string; currency: string; amount: number; services: number }[]
    consumption: {
      service: string
      customer: string
      currency: string
      amount: number
      items: number
      users: number
      tickets: number
      per_item: number | null
      per_user: number | null
      per_ticket: number | null
    }[]
    totals: Record<string, number>
    counts: { services: number; items: number; users: number; tickets: number }
    single: boolean
  }
}

export function costReportQuery(fromYm: number, toYm: number) {
  return queryOptions({
    queryKey: ['settings', 'company-reports', 'cost', fromYm, toYm],
    queryFn: () => apiGet<CostReportPage>(`/settings/company-reports/cost?from_ym=${fromYm}&to_ym=${toYm}`),
  })
}

export const COST_FORMATS = ['xlsx', 'csv', 'pdf'] as const

export type CostFormat = (typeof COST_FORMATS)[number]

export async function downloadCostReport(view: CostView, fromYm: number, toYm: number, format: CostFormat = 'xlsx'): Promise<void> {
  const out = await apiExchange(`/settings/company-reports/cost/export.${format}?view=${view}&from_ym=${fromYm}&to_ym=${toYm}`, { method: 'GET' })
  saveBytes(out.bytes, out.type, out.filename, `costs_${view}.${format}`)
}
